var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99996 5.16016C5.17086 5.15527 5.32711 5.0918 5.45406 4.95508L9.165 1.15625C9.27242 1.04883 9.33101 0.912109 9.33101 0.750977C9.33101 0.428711 9.07711 0.169922 8.75484 0.169922C8.59859 0.169922 8.44722 0.233398 8.33492 0.345703L5.00484 3.76855L1.665 0.345703C1.55269 0.238281 1.40621 0.169922 1.24508 0.169922C0.922811 0.169922 0.668904 0.428711 0.668904 0.750977C0.668904 0.912109 0.727498 1.04883 0.83492 1.15625L4.55074 4.95508C4.68258 5.0918 4.82906 5.16016 4.99996 5.16016Z",
    fill: "#232326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSelect);
export default __webpack_public_path__ + "static/media/arrow-select.4b16434b605054287b956c9d0d1525e9.svg";
export { ForwardRef as ReactComponent };